export const cacheEnabled = process.env.CACHE_ENABLED === 'true';
export const maxItemsInCache = 10; // Items
export const maxLocalStorageSize = 5; // MB
export const maxValueSize = 2; // MB
